import React, { useState } from "react";
import { Modal, Button } from "antd";
import Cookies from "js-cookie";

const UnauthorizedErrorModal = ({
  showUnauthorizedErrorModal,
  setShowUnauthorizedErrorModal,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleOk = () => {
    setModalText(
      "This popup will be closed after three seconds and user will be redirected to login page"
    );
    setConfirmLoading(true);
    setTimeout(() => {
      // clear up any user data to prevent other people from retrieving it
      // redirect user back to the login page
      Cookies.remove("jwtToken");
      localStorage.clear();
      setShowUnauthorizedErrorModal(false);
      setConfirmLoading(false);
      window.location.href = "/login";
    }, 3000);
  };

  return (
    <Modal
      title="Session Expired"
      open={showUnauthorizedErrorModal}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      footer={[
        <Button
          key="ok"
          type="primary"
          onClick={handleOk}
          loading={confirmLoading}
        >
          back to login
        </Button>,
      ]}
    >
      <p className="text-lg text-blue-900">
        Your session has expired. Please login in with your credentials again
      </p>
      <p className="text-xs font-light">{modalText}</p>
    </Modal>
  );
};

export default UnauthorizedErrorModal;
